module.exports = __webpack_public_path__ + "static/media/PlusGreenFilled.978a2b9b.svg";